import React, { useState, useEffect } from "react";
import { getTokens } from "../config/messaging_init_in_sw";
import axios from "axios";

const Notifications = ({propsData}) => {
  const [isTokenFound, setTokenFound] = useState(false);

  //console.log("Token found", isTokenFound);

  // To load once

  useEffect(() => {
    let data;
    let prevToken=  JSON.parse(localStorage.getItem("895u64jxdnvjkf-ghdfjg65-duindjdb-bdaab-jjkkffur"))
    async function tokenFunc() {
      data = await getTokens(setTokenFound);
      if (data!==prevToken) {
        //console.log("new token", data);
        //console.log("prev token", prevToken);
        axios.put(`${process.env.REACT_APP_URL}/api/user/update`,{fcm_token:data}, //proxy uri
                {
                  headers: {
                      authorization:`Bearer ${propsData.userData.token}`,
                    'Content-Type': 'application/json'
                  } 
              }).then(function (response) {
                  //console.log(response.data);
                 localStorage.setItem("895u64jxdnvjkf-ghdfjg65-duindjdb-bdaab-jjkkffur",JSON.stringify(data))
              }).catch((error) => {
                 //console.log(error);
              });
        
      }
      return data;
    }
   
    tokenFunc();// call this function if userData.data.fcm_token is expired only

  }, [setTokenFound]);

  return <></>;
};

Notifications.propTypes = {};

export default Notifications;